'use client'
import React, { useState, useEffect } from 'react';
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link';
import NavBarLanding from '@/components/NavBarLanding';
import Footer from '@/components/Footer';
import { SignFrom } from '@/components/Sign';

declare global {
    interface Window {
        Tally: any;
    }
}

export default function Contact() {
    const [signValue, setSignValue] = useState<string>('signup');
    const [toggleSignForm, setToggleSignForm] = useState<boolean>(false);
    const [email, setEmail] = useState('');
    const [emailSent, setEmailSent] = useState(false);

    useEffect(() => {
        const scriptUrl = 'https://tally.so/widgets/embed.js';
        if (typeof window.Tally === 'undefined' && !document.querySelector(`script[src="${scriptUrl}"]`)) {
            const script = document.createElement('script');
            script.src = scriptUrl;
            script.onload = loadTally;
            script.onerror = loadTally;
            document.body.appendChild(script);
        } else {
            loadTally();
        }

        function loadTally() {
            if (typeof window.Tally !== 'undefined') {
                window.Tally.loadEmbeds();
            } else {
                document.querySelectorAll('iframe[data-tally-src]:not([src])').forEach((iframeElement) => {
                    const iframe = iframeElement as HTMLIFrameElement;
                    iframe.src = iframe.dataset.tallySrc!;
                });
            }
        }
    }, []);

    return (
        <>
            <Head>
                <title>Eurekia !</title>
                <meta name="description" content="Generated by webzh" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>
            <main className="w-full items-center justify-center flex-col bg-main overflow-x-hidden relative gap-4">
                {
                    toggleSignForm ?

                        <div className='w-full sm:h-full h-screen flex justify-center items-center'>
                            {/* <style global jsx>{`
    #__next {
        height:100vh;
        width:100vw;
        overflow:hidden
      }
`}</style> */}
                            <div onClick={() => setToggleSignForm(false)} className='z-50 w-full h-full fixed top-0 left-0 flex justify-center items-center backdrop-blur-md bg-black bg-opacity-10'>
                            </div>
                            <div className='z-[1000] fixed flex justify-center'>
                                <SignFrom signValue={signValue} />
                            </div>
                        </div>
                        : null
                }
                < NavBarLanding
                    signValue={signValue as string}
                    setSignValue={setSignValue}
                    toggleSignForm={toggleSignForm}
                    setToggleSignForm={setToggleSignForm}
                />
                <section className="w-full flex flex-col items-center h-auto pt-[150px] gap-16">
                    <h1 className='font-medium text-3xl lg:text-[2.4vw] leading-tight flex sm:items-start items-center justify-center flex-col text-center'>
                        Contact
                    </h1>
                    <p className='w-4/5 flex justify-center text-center'>
                        Veuillez remplir le formulaire ci-dessous pour nous contacter.
                    </p>
                    <div className='w-full sm:w-3/5 flex justify-center h-[450px] flex-col items-center '>
                        <iframe
                            data-tally-src="https://tally.so/embed/w8aV2o?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                            loading="lazy"
                            width="80%"
                            height="auto"
                            frameBorder="0"
                            marginHeight={0}
                            marginWidth={0}
                            title="Nous contacter"
                        />
                        {
                            emailSent ?
                                <p>Nous avons bien reçu votre email, à bientôt !</p>
                                :
                                null
                        }
                    </div>
                </section>
                <Footer />
            </main>
        </>
    )
}
